import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import {
  Briefcase, AlertTriangle, Calendar, Bell, Users, Clock, TrendingUp,
} from "lucide-react";

const Kpi = ({ icon: Icon, label, value, color, testid, to }) => {
  const content = (
    <div className="ma-kpi" data-testid={testid}>
      <div className="ma-kpi-icon" style={{ background: color }}><Icon size={20} /></div>
      <div className="ma-kpi-body">
        <div className="ma-kpi-label">{label}</div>
        <div className="ma-kpi-value">{value ?? "—"}</div>
      </div>
    </div>
  );
  return to ? <Link to={to} className="ma-kpi-link">{content}</Link> : content;
};

export default function DashboardPage() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get("/dashboard").then(r => setData(r.data)).catch(e => setErr(e?.response?.data?.detail || "Errore"));
  }, []);

  if (err) return <div className="ma-error">{err}</div>;
  if (!data) return <div className="ma-loading">Caricamento…</div>;

  const c = data.counts;

  return (
    <div className="ma-page">
      <div className="ma-page-header">
        <h1 className="ma-h1" data-testid="dashboard-title">Dashboard</h1>
        <div className="ma-quick-actions">
          <Link to="/clients/new" className="ma-btn-secondary" data-testid="quick-new-client">+ Cliente</Link>
          <Link to="/practices/new" className="ma-btn-secondary" data-testid="quick-new-practice">+ Pratica</Link>
          <Link to="/calendar" className="ma-btn-secondary" data-testid="quick-new-event">+ Appuntamento</Link>
        </div>
      </div>

      <div className="ma-kpi-grid">
        <Kpi icon={Briefcase} label="Pratiche attive" value={c.active_practices} color="#B40000" testid="kpi-active" to="/practices" />
        <Kpi icon={Clock} label="Scadenze entro 7 gg" value={c.upcoming_deadlines_7d} color="#F59E0B" testid="kpi-upcoming" to="/practices" />
        <Kpi icon={AlertTriangle} label="Pratiche scadute" value={c.overdue_practices} color="#C62828" testid="kpi-overdue" to="/practices" />
        <Kpi icon={Users} label="Clienti totali" value={c.total_subjects} color="#2B2B2B" testid="kpi-subjects" to="/clients" />
        <Kpi icon={Calendar} label="Eventi oggi" value={c.events_today} color="#2E7D32" testid="kpi-events" to="/calendar" />
        <Kpi icon={Bell} label="Notifiche non lette" value={c.unread_notifications} color="#8A0000" testid="kpi-notifs" to="/notifications" />
      </div>

      <div className="ma-panel-grid">
        <div className="ma-panel">
          <div className="ma-panel-head">
            <TrendingUp size={16} /> <span>Pratiche per fase</span>
          </div>
          <div className="ma-panel-body">
            {data.phase_distribution.length === 0 && <div className="ma-empty">Nessuna pratica registrata.</div>}
            {data.phase_distribution.map(pd => (
              <div key={pd.phase} className="ma-dist-row">
                <div className="ma-dist-label">{pd.phase}</div>
                <div className="ma-dist-bar"><div className="ma-dist-fill" style={{width: `${Math.min(100, pd.count * 12)}%`}} /></div>
                <div className="ma-dist-count">{pd.count}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="ma-panel">
          <div className="ma-panel-head">
            <Clock size={16} /> <span>Ultime attività</span>
          </div>
          <div className="ma-panel-body">
            {data.recent_activity.length === 0 && <div className="ma-empty">Nessuna attività registrata.</div>}
            {data.recent_activity.map(a => (
              <div key={a.id} className="ma-activity-row" data-testid="activity-row">
                <div className="ma-activity-dot" />
                <div className="ma-activity-text">
                  <span className="ma-activity-action">{a.action}</span>
                  {a.entity_type && <span className="ma-activity-entity"> · {a.entity_type}</span>}
                </div>
                <div className="ma-activity-time">
                  {new Date(a.created_at).toLocaleString("it-IT", { day:"2-digit", month:"2-digit", year:"numeric", hour:"2-digit", minute:"2-digit"})}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
